module.exports = "pegasus_template/assets/icn_6.png";